import clsx from 'clsx'

import { sanitize } from '../lib/sanitize'
import { CardNote } from './CardNote'
import { TickIcon } from './icons/Tick'

export interface BenefitCardProps {
  className?: string
  title: preact.ComponentChildren
  description: string
  active?: boolean
}
export function BenefitCard({ title, description, className, active: enabled }: BenefitCardProps) {
  return (
    <div
      className={clsx(
        'flex flex-col relative overflow-hidden justify-start items-start p-4 transition-colors bg-black-20/20 rounded',
        className,
      )}>
      <p className="pr-6 font-semibold leading-relaxed ">{title}</p>
      <div
        className={clsx(
          'flex justify-center items-center leading-snug mt-3 transition-opacity',
          enabled ? 'opacity-100' : 'opacity-25',
        )}>
        {sanitize(description)}
      </div>
      <CardNote
        className={clsx(
          'w-10 h-10 text-white transition-colors duration-300',
          enabled ? 'before:bg-mint' : 'before:bg-navy/10',
        )}>
        <TickIcon className="w-3 h-3 mt-1.5 mr-1.5 stroke-2" />
      </CardNote>
    </div>
  )
}
